import { Grid } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    '& > *': {
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: '50%',
      },
    },
  },
}));

const StepContainer: React.FC = ({ children }) => {
  const classes = useStyles();

  return (
    <Grid className={classes.container} direction="column" spacing={6} container>
      {children}
    </Grid>
  );
};

export default StepContainer;
